import { useCallback } from 'react';
import { useApiGestao } from 'servicos/api-gestao/base';
import { normalizarDocumento } from 'utils/cpfcnpj-format';

export function useEmpresaExiste() {
  const { invocarApi, ...outrasPropriedades } = useApiGestao();

  const verificarSeEmpresaExiste = useCallback(
    async (cnpj: string) => {
      const url = `empresa/exists/${normalizarDocumento(cnpj)}`;
      const ret = await invocarApi({
        url,
        enviarTokenIntegracao: true,
        enviarTokenUsuario: false,
        forcarTokenIntegracao: false,
      });

      let retError = {};
      //ERRO NO TOKEN
      if (ret.statusCode === 401) {
        retError = await invocarApi({
          url,
          enviarTokenIntegracao: true,
          enviarTokenUsuario: false,
          forcarTokenIntegracao: true,
        });
      }
      return { ...ret, ...retError };
    },

    [invocarApi],
  );

  return {
    ...outrasPropriedades,
    verificarSeEmpresaExiste,
  };
}
